// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HhUOa","col":"styles_col__1jhgT"};